/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Free_DescriptionInputs */

const en_pricing_plans_free_description = /** @type {(inputs: Pricing_Plans_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic features for personal use`)
};

const es_pricing_plans_free_description = /** @type {(inputs: Pricing_Plans_Free_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones basicas para uso personal`)
};

/**
* | output |
* | --- |
* | "Basic features for personal use" |
*
* @param {Pricing_Plans_Free_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_free_description = /** @type {((inputs?: Pricing_Plans_Free_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Free_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_free_description(inputs)
	return es_pricing_plans_free_description(inputs)
});